import { API } from "../../../utils";

export const getPointPromotionsListApi = async () => {
  const res = await API.get(`points-promotions`);
  return res.data;
};

export const createPointPromotionApi = async (payload) => {
  const res = await API.post(`points-promotions`, payload);
  return res.data;
};

export const updatePointPromotionApi = async (id, payload) => {
  const res = await API.put(`points-promotions/${id}`, payload);
  return res.data;
};

export const getPointPromotionDetailsApi = async (id) => {
  const res = await API.get(`points-promotions/${id}`);
  return res.data;
};

export const getPointPromotionProductsApi = async (promotionId, params) => {
  const res = await API.get(`points-promotions/${promotionId}/products`, {
    params,
  });
  return res.data;
};

export const deletePointPromotionProductApi = async (
  promotionId,
  productId,
) => {
  const res = await API.delete(
    `points-promotions/${promotionId}/products/${productId}`,
  );
  return res.data;
};

export const assignProductToPointPromotionApi = async (
  promotionId,
  payload,
) => {
  const res = await API.post(
    `points-promotions/${promotionId}/products`,
    payload,
  );
  return res.data;
};

export const getPointPromotionStoresApi = async (promotionId, params) => {
  const res = await API.get(`points-promotions/${promotionId}/stores`, {
    params,
  });
  return res.data;
};

export const deletePointPromotionStoreApi = async (promotionId, storeId) => {
  const res = await API.delete(
    `points-promotions/${promotionId}/stores/${storeId}`,
  );
  return res.data;
};

export const assignStoresToPointPromotionApi = async (promotionId, payload) => {
  const res = await API.post(
    `points-promotions/${promotionId}/stores`,
    payload,
  );
  return res.data;
};

export const changePointPromotionStatusApi = async (id) => {
  const res = await API.post(`points-promotions/${id}/change-status`);
  return res.data;
};

export const getLoyaltyCardTypeDetailsApi = async (id) => {
  const res = await API.get(`loyalty-card_types/${id}`);
  return res.data;
};

export const getLoyaltyCardsListApi = async (query, pagination) => {
  const { pageIndex, pageSize } = pagination;
  const res = await API.get(
    `loyalty-card-groups?page=${pageIndex}&per_page=${pageSize}`,
    query,
  );
  return res.data;
};

export const deletePointPromotionApi = async (id) => {
  const res = await API.delete(`points-promotions/${id}`);
  return res.data;
};
